@if(isBrowser){
<div [ngClass]="{'navbar-open-wrapper': isNavbarOpen}" class="main-wrapper">
  <app-header-disclaimer-banner></app-header-disclaimer-banner>
  @if(topbarType == 'MEMBERPORTAL'){
  <app-memberportal-navbar (navbarChange)="onnavbarChange($event)"></app-memberportal-navbar>
  } @else {

  @if(showNavbar){
  <ng-container *ngIf="isMiniEnv$; else normalHeader">
    <app-minienv-navbar></app-minienv-navbar>
  </ng-container>

  <ng-template #normalHeader>
    <app-navbar (navbarChange)="onnavbarChange($event)"></app-navbar>
  </ng-template>

  }
  }

  <!-- partial:sidebar -->
  <!-- <app-sidebar></app-sidebar> -->
  <!-- partial -->

  <div class="page-wrapper">
    <!-- partial:navbar -->
    <!-- partial -->

    <div class="page-content" [ngClass]="{ 'page-content-webview': this.sharedDataService.isAppWebView(),'set-padding-without-banner': (hasWellnessMembership || environment.memberPortalOnly) }">
      @if(!isMiniEnv$){
      <app-cobranding-banner (bannerRendered)="isCobranded = true"></app-cobranding-banner>
      }
      <div contentAnimate [ngClass]="isCobranded ? 'mt-5' : ''">
        <router-outlet></router-outlet>
      </div>
    </div>

    <!-- partial:footer -->
    @if(!sharedDataService.user()){
    <ng-container *ngIf="isMiniEnv$; else normalfooter">
      @if(!includedURL()){
      <app-minienv-footer></app-minienv-footer>
      }
    </ng-container>
    <ng-template #normalfooter>
      <app-footer></app-footer>
    </ng-template>
    }
    <!-- partial -->
  </div>
</div>
}

<ngx-ui-loader
[hasProgressBar]="false"
[fgsColor]="loaderColor"
></ngx-ui-loader>
<app-error-dialog (onModalClose)="modalClose()"></app-error-dialog>
